import type {
  PatientTaskSearch,
  PractitionerTaskSearch,
  TaskCreate,
  TaskUpdateOverdue,
  TaskUpdateStatus,
} from '@quromedical/models';
import { trpcClient } from 'trpc';

export class TaskApi {
  public getPatientSWRKey(id: string) {
    return `patient-tasks/${id}`;
  }

  public readonly userTasksBaseSWRKey = 'user-tasks';

  public async patientCreate(body: TaskCreate) {
    await trpcClient.task.create.mutate(body);
  }

  public async updateStatus(body: TaskUpdateStatus) {
    await trpcClient.task.update.mutate(body);
  }

  public async updateOverdue({ id, dueDate, note }: TaskUpdateOverdue) {
    await trpcClient.task.update.mutate({
      id,
      dueDate: dueDate.toString(),
      note,
    });
  }

  public async patientGet(body: PatientTaskSearch) {
    await trpcClient.patient.getTasks.query(body);
  }

  public async practitionerGet(body: PractitionerTaskSearch) {
    await trpcClient.practitioner.getTasks.query(body);
  }
}
